import { TrackObj } from "../../pages/MyTracks/types";
import { SORT_OPTIONS } from "./type";

const getTracksSortedByTitle = (data: TrackObj[]): TrackObj[] => {
  return data.sort((a, b) => {
    if (a.track && b.track) {
      return a.track?.getTitle().localeCompare(b.track?.getTitle());
    } else {
      return 0;
    }
  });
};

const getTracksSortedByArtist = (data: TrackObj[]): TrackObj[] => {
  return data.sort((a, b) => {
    if (a.track && b.track) {
      return a.track?.getArtist().localeCompare(b.track?.getArtist());
    } else {
      return 0;
    }
  });
};

const getTracksSortedByLastModified = (data: TrackObj[]): TrackObj[] => {
  return data.sort((a, b) => {
    if (a.track && b.track) {
      return a.track?.getModifiedTimestamp() - b.track?.getModifiedTimestamp();
    } else {
      return 0;
    }
  });
};

const getTracksSortedByDateCreated = (data: TrackObj[]): TrackObj[] => {
  return data.sort((a, b) => {
    if (a.track && b.track) {
      return a.track?.getTimestamp() - b.track?.getTimestamp();
    } else {
      return 0;
    }
  });
};

export const sortHelperMap: Record<string, (data: TrackObj[]) => TrackObj[]> = {
  [SORT_OPTIONS.TITLE]: getTracksSortedByTitle,
  [SORT_OPTIONS.ARTIST]: getTracksSortedByArtist,
  [SORT_OPTIONS.LAST_MODIFIED]: getTracksSortedByLastModified,
  [SORT_OPTIONS.DATE_CREATED]: getTracksSortedByDateCreated,
};
